
const LANGUAGE_LOCL_STORAGE_KEY = 'lang';


export const languageService = {
    setLanguage,
    getLanguage,
    getCountryCodeByLanguageCode,
    getLanguageCodeByCoutryCode,
    getLanguageDirection
};

function setLanguage(lang) {
    localStorage.setItem(LANGUAGE_LOCL_STORAGE_KEY, lang);
}

function getLanguage() {
    var lang = localStorage.getItem(LANGUAGE_LOCL_STORAGE_KEY);
    if (!lang || lang === '') {
        // set default language to hebrew - HE
        lang = 'HE';
    }
    return lang;
}

function getCountryCodeByLanguageCode(langCode) {
    switch (langCode) {
        case 'HE':
            return 'IL';
        case 'EN':
            return 'US';
        case 'AE':
            return 'AE';
        case 'RU':
            return 'RU';
        default:
            return 'IL'
    }
}

function getLanguageCodeByCoutryCode(countryCode) {
    switch (countryCode) {
        case 'IL':
            return 'HE';
        case 'US':
            return 'EN';
        case 'AE':
            return 'AE';
        case 'RU':
            return 'RU';
        default:
            return 'HE'
    }
}

function getLanguageDirection(langCode) {
    switch (langCode) {
        case 'HE':
        case 'AE':
            return 'rtl';
        case 'EN':
        case 'RU':
            return 'ltr';
        default:
            return 'rtl'
    }
}


export default languageService;